<template>
    <div class="pane1">
        <div class="pane1-left">
            <h4 style="padding-bottom: 10px;">联盟</h4>
            <div class="common-header">
                <el-input
                        size="small"
                        placeholder="请输入联盟ID查询"
                        v-model="searchUnionId"/>
            </div>
            <el-radio-group
                    class="pane1-radios common-scroll"
                    v-model="searchKey"
                    @change="getList()">
                <el-radio label="">
                    所有联盟
                </el-radio>
                <el-radio
                        v-for="item of unionList"
                        :key="item.id"
                        :label="item.id">
                    {{item.tribeName}}(ID:{{item.randomId}})
                </el-radio>
            </el-radio-group>
        </div>
        <div class="pane1-right">
            <div class="common-header">
                <el-input
                        v-model="searchClubId"
                        size="small"
                        class="common-el-input-small"
                        placeholder="请输入俱乐部ID查询"/>
                <el-button size="small" type="primary" @click="getList()">搜索</el-button>
                <div class="common-header-right">
                    <el-button size="small" type="primary" @click="saveSelect()">保存</el-button>
                </div>
            </div>
            <div class="common-table" style="min-height: auto">
                <el-table
                        ref="clubTable"
                        v-loading="loading"
                        :data="firstChargeConfigClubList.beanList"
                        height="100%"
                        row-key="id"
                        @selection-change="selectionVal = $event">
                    <el-table-column type="selection"/>
                    <el-table-column label="俱乐部昵称" align="center" prop="clubName"/>
                    <el-table-column label="俱乐部ID" align="center" prop="clubRandomId"/>
                    <el-table-column label="活动限额" align="center">
                        <template slot-scope="scope">
                            <el-input size="mini" type="number" v-model="scope.row.countLimit" placeholder="请输入">
                                <template slot="append">金豆</template>
                            </el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                    class="common-el-pagination"
                    layout="prev,pager,next,jumper"
                    background
                    :page-size="10"
                    :pager-count="5"
                    :total="firstChargeConfigClubList.total"
                    :current-page="currentPage"
                    @current-change="currentChange($event)"/>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchKey: '',
                selectionVal: [],//选中的俱乐部
                searchUnionId: '',
                searchClubId: '',
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('union', ['allUnionList']),
            ...mapState('activity', ['firstChargeConfigClubList']),
            unionList() {
                if (this.searchUnionId) {
                    return this.allUnionList.filter(item => {
                        if (this.searchUnionId === item.randomId) {
                            return true
                        }
                    })
                }
                return this.allUnionList
            }
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('activity', ['getFirstChargeConfigClubList', 'updateFirstChargeClubList']),
            getList(page = 1) {
                this.currentPage = page;
                this.loading = true;
                this.getFirstChargeConfigClubList({
                    clubRandomId: this.searchClubId,
                    tribeId: this.searchKey,
                    page,
                    size: 10
                }).then(() => {
                    this.loading = false;
                    this.selectionRow()
                })
            },
            selectionRow() {
                this.firstChargeConfigClubList.beanList.forEach(item => {
                    this.$refs.clubTable.toggleRowSelection(item, item.checked)
                });
            },
            currentChange(page) {
                let newSelectClubIds = this.selectionVal.map(item => item.id);
                let oldSelectClubIds = this.firstChargeConfigClubList.beanList.filter(item => item.checked).map(item => item.id);
                let diff = false;
                if (newSelectClubIds.length !== oldSelectClubIds.length) {
                    diff = true;
                } else {
                    oldSelectClubIds.forEach(item => {
                        if (newSelectClubIds.indexOf(item) < 0) {
                            diff = true;
                        }
                    });
                }
                if (diff) {
                    this.$confirm('是否保存当前页修改', '提示', {
                        type: 'info'
                    }).then(() => {
                        this.saveSelect(page);
                    }).catch(() => {
                    });
                } else {
                    this.getList(page)
                }
            },
            // 保存俱乐部配置
            saveSelect(page = null) {
                let ok = true;
                let selectClubIds = this.selectionVal.map(item => item.clubId);
                let items = this.firstChargeConfigClubList.beanList.map(item => {
                    if (selectClubIds.indexOf(item.clubId) > -1 && !item.countLimit) {
                        ok = false
                    }
                    if(item.countLimit < 0){
                        ok = false
                    }
                    return {
                        checked: selectClubIds.indexOf(item.clubId) > -1,
                        clubId: item.clubId,
                        countLimit: item.countLimit
                    }
                });
                if (!ok) {
                    this.$message.error('请为选中的俱乐部设置限额(大于0)');
                    return
                }
                this.loading = true;
                this.updateFirstChargeClubList({
                    items
                }).then(() => {
                    this.loading = false;
                    this.$message.success('保存成功');
                    if (page) {
                        // 翻页保存时 请求列表
                        this.getList(page);
                    } else {
                        // 保存当前页 更新列表
                        this.getList(this.currentPage);
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>

    .pane1 {
        display: flex;
        padding: 30px 20px 20px;
        background-color: #fff;
        //width:808px;
        :global(.el-collapse) {
            margin-top: 15px;
        }
        :global(.el-collapse-item__header) {
            padding-left: 10px;
            border: 0;
        }
        :global(.el-collapse-item__wrap) {
            border: 0;
        }
        &-left {
            width: 230px;
            height: 430px;
            padding-right: 10px;
            margin-right: 10px;
            border-right: 2px solid $border-color;
            box-sizing: border-box;
        }
        &-right {
            display: flex;
            flex-flow: column;
            width: 808px - 240;
            height: 430px;
        }
        .common-header-right {
            margin-top: 0;
        }
        .common-el-pagination {
            padding-top: 10px !important;
        }
        &-radios {
            display: block;
            height: 360px;
            overflow-y: scroll;
            :global(.el-radio) {
                display: block;
                margin-top: 15px;
            }
            :global(.el-radio__input) {
                position: absolute;
                opacity: 0;
            }
        }
    }
</style>